export default "__VITE_ASSET__53d6f071__"